import { render, staticRenderFns } from "./PasteCode.vue?vue&type=template&id=5d96ca48"
import script from "./PasteCode.vue?vue&type=script&lang=js"
export * from "./PasteCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports